// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyBENtITt0TYlD5vA4ZDFJ3nxkwh91Ef5wg',
  authDomain: 'finca-naundrup.firebaseapp.com',
  projectId: 'finca-naundrup',
  storageBucket: 'finca-naundrup.appspot.com',
  messagingSenderId: '42338548618',
  appId: '1:42338548618:web:0d3b495c08ff5e8952e673',
  measurementId: 'G-3782ZN8S48'
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const firestore = getFirestore(app);
const storage = getStorage(app);

export { firestore, storage };
